module.exports = __webpack_public_path__ + "34bc1a131cb340e897764dadec50364a.pdf";